import BaseService from "./base.service";

export default class BuscasService extends BaseService {
    constructor(filters = {}) {
        // Construir URL com filtros
        const params = new URLSearchParams();

        // Adicionar parâmetros de busca
        if (filters.q) {
            params.append("q", filters.q);
        }

        if (filters.tipos && filters.tipos.length > 0) {
            params.append("tipos", Array.isArray(filters.tipos) ? filters.tipos.join(",") : filters.tipos);
        }

        if (filters.ordering) {
            params.append("ordering", filters.ordering);
        }

        if (filters.page) {
            params.append("page", filters.page);
        }

        // Construir URL final
        const queryString = params.toString();
        const endpoint = queryString ? `buscas?${queryString}` : "buscas";

        super(endpoint);
    }

    // Método específico para buscar com filtros
    async search(searchParams = {}) {
        const { q = "", tipos = [], ordering = "", page = 1 } = searchParams;

        // Reconstruir o service com novos parâmetros
        const params = new URLSearchParams();

        if (q) params.append("q", q);
        if (tipos.length > 0) params.append("tipos", Array.isArray(tipos) ? tipos.join(",") : tipos);
        if (ordering) params.append("ordering", ordering);
        if (page) params.append("page", page);

        const queryString = params.toString();
        this.resource = queryString ? `buscas/?${queryString}` : "buscas";

        try {
            const result = await this.list();
            // Ensure consistent response structure
            return {
                count: result.count || 0,
                next: result.next || null,
                previous: result.previous || null,
                results: result.results || [],
                error: result.error || false,
                message: result.message || null,
            };
        } catch (error) {
            console.error("[BuscasService] Erro ao realizar busca:", error);
            return {
                error: true,
                message: "Erro ao realizar busca",
                count: 0,
                next: null,
                previous: null,
                results: [],
            };
        }
    }

    // Método para busca simples por texto
    async searchByText(query, page = 1) {
        return this.search({ q: query, page });
    }

    // Método para busca por tipo específico
    async searchByType(tipos, page = 1) {
        return this.search({ tipos, page });
    }

    // Método para busca com ordenação
    async searchWithOrdering(query, ordering, page = 1) {
        return this.search({ q: query, ordering, page });
    }

    // Método para busca completa com todos os filtros
    async searchComplete({ q, tipos, ordering, page = 1 }) {
        return this.search({ q, tipos, ordering, page });
    }
}
